import React, { useEffect, useState } from 'react'
import './index.sass'
import { likePost, unlikePost, bookmarkPost, unBookmarkPost } from '../../api/feed'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'


function FeedCardActions({ likesCount, postId, type, username, likeMap, bookmarkMap, commentMap, onBookmark, onTipClick }) {

    const history = useHistory()
    const [isLiked, setIsLiked] = useState(false);
    const [likesCountState, setLikesCountState] = useState(likesCount);
    const [isLiking, setIsLiking] = useState(false);

    const [isBookmarked, setIsBookmarked] = useState(false);
    const [isBookmarking, setIsBookmarking] = useState(false);
    const id = useSelector(store => store.userState.id);

    useEffect(() => {
        try {
            for (var i = 0; i < Object.entries(likeMap).length; i++) {
                if (Object.entries(likeMap)[i][0] == id && Object.entries(likeMap)[i][1] == true) {
                    setIsLiked(true);
                    break;
                }
            }
        } catch {

        }
    }, [likeMap])

    useEffect(() => {
        try {
            for (var i = 0; i < Object.entries(bookmarkMap).length; i++) {
                if (Object.entries(bookmarkMap)[i][0] == id && Object.entries(bookmarkMap)[i][1] == true) {
                    setIsBookmarked(true);
                    break;
                }
            }
        } catch {
        }
    }, [bookmarkMap])

    const handleLikePost = async () => {
        //setIsLiking(true);
        if (!isLiking) {
            setIsLiking(true);
            setIsLiked(true);
            setLikesCountState(likesCountState => likesCountState + 1)
            await likePost(postId);
            setIsLiking(false);
        }


    }

    const handleUnlikePost = async () => {
        //setIsLiking(true);
        if (!isLiking) {
            setIsLiking(true);
            setIsLiked(false);
            setLikesCountState(likesCountState => likesCountState - 1)
            await unlikePost(postId)
            setIsLiking(false);
        }
    }


    const handleBookmarkPost = async () => {
        setIsBookmarking(true);
        setIsBookmarked(true);
        await bookmarkPost(postId);
        setIsBookmarking(false);
        onBookmark()
    }

    const handleUnBookmarkPost = async () => {
        setIsBookmarking(true);
        setIsBookmarked(false);
        await unBookmarkPost(postId);
        setIsBookmarking(false);
    }

    useEffect(() => {
        setLikesCountState(likesCount)
    }, [])

    useEffect(() => {
        setLikesCountState(likesCount)
    }, [likesCount, commentMap])

    const gotoPost = () => {
        history.push({
            pathname: (type == 1) ? `/post/${postId}/img` : `/post/${postId}/mp4`
        })
    }


    return (
        <div className="feed-actions">
            <div className="feed-body-left">
                <div className="feed-action">
                    {!isLiked ? <img onClick={!isLiking ? handleLikePost : null} src={require('../../assets/icons/heart.svg')} /> : <img onClick={!isLiking ? handleUnlikePost : null} src={require('../../assets/icons/heart_a.svg')} />}
                    <p>{likesCountState}</p>
                </div>
                <div className="feed-action" onClick={gotoPost}>
                    <img src={require('../../assets/icons/comment.svg')} />
                    <p>{Object.entries(commentMap).length || [].length}</p>
                </div>
                <div onClick={onTipClick} className="feed-action">
                    <img src={require('../../assets/icons/tip.svg')} />
                    <p>SEND TIP</p>
                </div>
            </div>
            <div className="feed-body-right">
                <div className="feed-action">
                    {!isBookmarked ? <img onClick={!isBookmarking ? handleBookmarkPost : null} src={require('../../assets/icons/bookmark.svg')} /> : <img onClick={!isBookmarking ? handleUnBookmarkPost : null} src={require('../../assets/icons/bookmark_a.svg')} />}
                </div>
            </div>
        </div>

    )
}


export default (FeedCardActions)